import React from "react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { PageHero } from "@/components/site/PageHero";
import { SectionHeading } from "@/components/site/ui";
import { SellerSection } from "@/components/site/SellerSection";
import { Testimonials } from "@/components/site/Testimonials";
import { LeadForm } from "@/components/site/LeadForm";
import { ContactSection } from "@/components/site/ContactSection";
import { ROUTES } from "@/components/site/data";

const IMG = "https://images.pexels.com/photos/5223143/pexels-photo-5223143.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000";

export default function SellPage() {
  usePageMeta(
    "Sell Your Home | Wallstreet Realty",
    "Sell with strategy in Southern California. Request a home value, build a pricing strategy, prepare your property, and connect with a Wallstreet Realty listing professional."
  );
  return (
    <>
      <PageHero
        crumb="Sell"
        eyebrow="For Sellers"
        title="Sell With Strategy"
        subtitle="Understand your home value, prepare your property, and create a smart plan before going to market."
        image={IMG}
        ctas={[
          { label: "Request Home Value", href: "#valuation", testid: "sell-hero-value" },
          { label: "Talk to a Listing Pro", href: ROUTES.contact, variant: "outline", testid: "sell-hero-pro" },
        ]}
      />
      <SellerSection />
      <section id="valuation" className="py-16 lg:py-24 bg-[#F5F5F5] scroll-mt-[70px]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            eyebrow="Home Valuation"
            title="Request Your Home Value"
            subtitle="Share your property details and we'll follow up with a real valuation and pricing strategy, not an algorithm."
            center
          />
          <div className="mt-10">
            <LeadForm variant="seller" testid="valuation-form" />
          </div>
        </div>
      </section>
      <Testimonials />
      <ContactSection />
    </>
  );
}
